
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/responsible-play",
      function () {
        return require("private-next-pages/responsible-play/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/responsible-play"])
      });
    }
  